// extracted by mini-css-extract-plugin
export default {"main":"Isakovo_main__LHoXK","title":"Isakovo_title__6kngZ","imgContainer":"Isakovo_imgContainer__hIisw"};